import { useQuery } from '@zg-rentals/react-query5';
import {
  RentalManagerGuestSupportWebApiHandler_getHelpArticles,
  RentalManagerGuestSupportWebApiHandler_getHelpTopics,
  RentalManagerUserSupportWebApiHandler_getHelpArticles,
  RentalManagerUserSupportWebApiHandler_getHelpTopics,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  GuestSupportGetHelpTopicsResponseWebDto,
  RentalManagerSupportHelpArticlesResponseDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

export const useGetHelpArticles = ({ category = '', topic = '', isLoggedIn = false }, queryOptions = {}) => {
  return useQuery<RentalManagerSupportHelpArticlesResponseDto, Error>({
    queryKey: ['getHelpArticles', category, topic],
    queryFn: async () => {
      const getParams = { category, topic };
      return isLoggedIn
        ? RentalManagerUserSupportWebApiHandler_getHelpArticles(getParams)
        : RentalManagerGuestSupportWebApiHandler_getHelpArticles(getParams);
    },
    meta: {
      tags: ['helpArticles'],
      context: { api: 'support', details: 'getHelpArticles' },
    },
    ...queryOptions,
    staleTime: 10 * 60 * 1000,
  });
};

export const useGetHelpTopics = ({ isLoggedIn = false }, queryOptions = {}) => {
  return useQuery<GuestSupportGetHelpTopicsResponseWebDto, Error>({
    queryKey: ['getHelpTopics'],
    queryFn: async () => {
      return isLoggedIn
        ? RentalManagerUserSupportWebApiHandler_getHelpTopics()
        : RentalManagerGuestSupportWebApiHandler_getHelpTopics();
    },
    meta: {
      tags: ['helpTopics'],
      context: { api: 'support', details: 'getHelpTopics' },
    },
    ...queryOptions,
    staleTime: 10 * 60 * 1000,
  });
};
